export enum AnalyticsEvent {
    REDITECTED_FROM_BETA_TO_PLATFORM = 'Redirected from beta to platform',

    SMART_REPLIES_VIEWED = 'Smart replies viewed',
    SMART_REPLY_SELECTED = 'Smart reply selected',

    ARCHIVED_CONVERSATIONS_VIEWED = 'Archived conversations viewed',

    NOTIFICATION_ALERT_DISMISSED = 'Notification alert dismissed',
    NOTIFICATION_REQUEST_DENIED = 'Notification request denied',
    NOTIFICATION_REQUEST_GRANTED = 'Notification request granted',

    SHORTCUT_KEY_USED = 'Shortcut key used',
    BUTTON_CLICKED = 'Button clicked',

    VACANT_PROPERTIES_NOTIFICATIONS_DISMISSED = 'Vacant properties notifications dismissed',


    USED_SMART_NOTIFICATION_OPEN_SMART_REPLIES = 'User opened smart replies from smart notification',
    USED_SMART_NOTIFICATION_CHANGE_STAGE = 'User changed lead stage from smart notification',
    USED_SMART_NOTIFICATION_OPEN_SNIPPETS = 'User opened snippets from smart notification',
    USED_SMART_NOTIFICATION_SCHEDULE_TOUR = 'User opened schedule tour modal from smart notification',

    INVITE_TO_TOUR_CLICKED = 'Invite to tour button clicked',
    INVITE_TO_APPLY_CLICKED = 'Invite to apply button clicked',

    CUSTOM_DATE_RANGE_SELECTED = 'Custom date range selected',
    CUSTOM_DATE_RANGE_SAVED = 'Custom date range saved',
    CUSTOM_DATE_RANGE_CANCELLED = 'Custom date range cancelled',

    CLICIKED_ON_GO_TO_PROPERTIES_IN_VACANT_ALERT = 'Clicked on go to properties in vacant properties alert',
    CLICKED_ON_DISMISS_VACANT_ALERT = 'Clicked on dismiss vacant properties alert',

    CLICKED_CONFIRM_TOUR = 'Clicked confirm tour',
    CLICKED_CANCEL_TOUR = 'Clicked cancel tour',
}
